/** Which kinds of organization an account owns. Replaces the legacy `users.role` label as a gate. */
export interface OwnedKinds {
  readonly venues: boolean;
  readonly properties: boolean;
}

export const NO_OWNED_KINDS: OwnedKinds = { venues: false, properties: false };

/** The slice of a membership needed to tell what an account owns. */
export interface OwnerMembershipLike {
  readonly role: string;
  readonly status: string;
  readonly organization: {
    readonly kind: "VENUE" | "PROPERTY";
    readonly active: boolean;
  };
}

interface OwnedKindsInput {
  /** Empty when the viewer may not read memberships (FINANCE). */
  readonly memberships: readonly OwnerMembershipLike[];
  readonly ownedVenues: readonly unknown[];
  readonly ownedProperties: readonly unknown[];
}

/**
 * An account owns a kind when it holds an ACTIVE OWNER membership in an active
 * organization of that kind, or (for viewers that cannot read memberships)
 * when the user detail lists venues or properties it owns.
 */
export function ownedKindsOf(input: OwnedKindsInput): OwnedKinds {
  const owns = (kind: "VENUE" | "PROPERTY") =>
    input.memberships.some(
      (m) =>
        m.role === "OWNER" &&
        m.status === "ACTIVE" &&
        m.organization.active &&
        m.organization.kind === kind,
    );
  return {
    venues: owns("VENUE") || input.ownedVenues.length > 0,
    properties: owns("PROPERTY") || input.ownedProperties.length > 0,
  };
}
